module.exports = __webpack_public_path__ + "img/icone_white.0a04e867.png";